import { render, staticRenderFns } from "./Decline.vue?vue&type=template&id=283c1ada"
import script from "./Decline.vue?vue&type=script&lang=js"
export * from "./Decline.vue?vue&type=script&lang=js"
import style0 from "./Decline.vue?vue&type=style&index=0&id=283c1ada&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports